import { commentsItems } from '@/mocks/home';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="section-container">
        <h2 className="section-title">读者评价</h2>
        <p className="section-subtitle">来自真实漫画爱好者的使用反馈与推荐</p>

        <div className="max-w-3xl mx-auto space-y-4">
          {commentsItems.map((item) => (
            <div
              key={item.id}
              className="p-5 md:p-6 bg-background-50 rounded-xl border border-background-200"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="font-heading text-sm font-bold text-foreground-950 whitespace-nowrap">
                      {item.name}
                    </span>
                    <span className="px-1.5 py-0.5 rounded text-[10px] font-medium bg-accent-100 text-accent-700 whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                  <span className="text-xs text-foreground-400">{item.date}</span>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {item.content}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}